import { render, staticRenderFns } from "./comite-convivencia.vue?vue&type=template&id=a985bed8&"
import script from "./comite-convivencia.vue?vue&type=script&lang=js&"
export * from "./comite-convivencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports